var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 68,
    viewBox: "0 0 18 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2.968L10.04 2.968L10.04 4.552L8 4.552L8 2.968ZM8 15.6946L10.04 15.6946L10.04 17.2786L8 17.2786L8 15.6946ZM8 28.4211L10.04 28.4211L10.04 30.0051L8 30.0051L8 28.4211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 52.75V64.625",
    stroke: "white",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.625 60.875L9 65.25L13.375 60.875",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125 56.875C13.2681 55.9745 14 54.5907 14 53.0389C14 50.325 11.7614 48.125 9 48.125C6.23858 48.125 4 50.325 4 53.0389C4 54.5907 4.73192 55.9745 5.875 56.875",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 68,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/bottom.a2120d0e7bd72572b117d82a34db6ee3.svg";
export { ForwardRef as ReactComponent };